import React from "react";
import { Link } from "react-router-dom";
import Img_Finance from "../../img/finance.svg";
const LandingPage = () => {
  return (
    <div className="container min-vh-100">
      <div className="row  min-vh-100  d-flex align-items-center ">
        <div className="col-lg-7 d-flex align-items-center ">
          <h2 className="display-4 d-none d-md-block text-center p-5">
            <p>Lleva un seguimiento de tus gastos con tu famila</p>
            <Link
              to="/dashboard"
              className="btn  btn-outline-dark mt-5 shadow-sm btn-block btn-lg"
            >
              Ir a los gastos{" "}
            </Link>
          </h2>
          <h2 className="display-5 d-md-none text-center p-5">
            <p>
              {" "}
              Lleva un seguimiento de tus gastos con cualquier grupo de personas
            </p>
            <Link
              to="/dashboard"
              className="btn  btn-outline-dark mt-5 shadow-sm btn-block btn-lg"
            >
              Ir a los gastos{" "}
            </Link>
          </h2>
        </div>

        <div className="col-lg-5 d-flex align-items-center   ">
          <img src={Img_Finance} className="img-fluid p-sm-5 p-lg-0 " alt="" />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
